import api from '../api'

// initial state
const state = {
  data: [],
  pageCount: 0,
  totalCount: 0,
  pageIndex: 1,
  pageSize: 10,
  students: []
}

// getters
const getters = {
  groups: state => state.data,
  groupCount: state => state.totalCount,
  groupIndex: state => state.pageIndex,
  groupPageSize: state => state.pageSize,
  groupPageCount: state => state.pageCount,
  studentsInGroup: state => state.students
}

// actions
const actions = {
  getGroups: ({ commit, state }, data) => {
    data = data || {}
    let config = {
      pageIndex: data.pageIndex || state.pageIndex,
      pageSize: data.pageSize || state.pageSize
    }

    return api.GroupMgr.Group.getList(config)
      .then((response) => {
        commit('groupsUpdated', response.data)
      })
  },

  addGroup: ({ commit }, data) => {
    return api.GroupMgr.Group
      .post(JSON.parse(JSON.stringify(data)))
  },

  getGroup: ({ commit }, id) => {
    return api.GroupMgr.Group.get(id)
  },

  editGroup: ({ commit }, data) => {
    return api.GroupMgr.Group
      .patch(data.id, JSON.parse(JSON.stringify(data.data)))
  },

  deleteGroup: ({ commit, dispatch, state }, id) => {
    commit('removeGroup', id)
    return api.GroupMgr.Group.delete(id)
      .then((response) => {
        if (state.data.length === 0 && state.pageIndex > 1) {
          dispatch('getGroups', { pageIndex: state.pageIndex - 1 })
        }
      })
  },

  exportGroup: (groupId) => {
    return api.GroupMgr.Export(groupId)
  },

  changePageGroups ({ commit, dispatch }, page) {
    commit('groupEditAttr', {
      attr: 'pageIndex',
      value: page
    })
    dispatch('getGroups')
  },

  getStudentsInGroup ({ commit }, groupId) {
    api.StudentMgr.Student
      .get({
        groupId: groupId,
        pageSize: 100
      })
      .then((response) => {
        commit('studentsInGroupUpdated', response.data)
      })
  },

  addStudentToGroup ({ dispatch }, payload) {
    api.GroupMgr
      .add(payload.groupId, payload.studentId)
      .then((response) => {
        dispatch('getStudentsInGroup', payload.groupId)
        dispatch('initStudents')
      })
  },

  removeStudentToGroup ({ dispatch }, payload) {
    api.GroupMgr
      .remove(payload.groupId, payload.studentId)
      .then((response) => {
        dispatch('getStudentsInGroup', payload.groupId)
        dispatch('initStudents')
      })
  }
}

// mutations
const mutations = {
  groupsUpdated (state, payload) {
    state.data = payload.data
    state.pageCount = payload.pageCount
    state.totalCount = payload.totalCount
    state.pageIndex = payload.pageIndex
    state.pageSize = payload.pageSize
  },

  groupEditAttr (state, payload) {
    state[payload.attr] = payload.value
  },

  studentsInGroupUpdated (state, payload) {
    state.students = payload.data
  },

  removeGroup (state, payload) {
    let idx = state.data.map((e) => { return e.id }).indexOf(payload)
    if (idx > -1) {
      state.data.splice(idx, 1)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/group.js